// extracted by mini-css-extract-plugin
module.exports = {"ticket-detail-card-res":"_3pX5DRCSgDLkejFzpzjxnb","ticket-detail-card-mobile":"_1uWoV7kkDp5SOOVB73NwaL"};